import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import ConfigErrorPage from './components/ConfigErrorPage';
import { AppAuthProvider } from './auth/AppAuthProvider';

// Renders the app, or a config error page when required environment variables are missing.
// The auth provider is never mounted without a valid Cognito config.
const Root = ({ missingConfig = [] }) => {
  if (missingConfig.length > 0) {
    return (
      <ChakraProvider>
        <ConfigErrorPage missing={missingConfig} />
      </ChakraProvider>
    );
  }

  return (
    <AppAuthProvider>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </AppAuthProvider>
  );
};

export default Root;
